import swagStoreBannerImage from "@assets/images/add-to-swag-banner.png";

export const addSwagToShopBannerData = {
  name: "add-swag-to-shop",
  primaryText: "Add swag to your shop",
  secondaryText: "We'll design 100+ custom branded swag items for you to include in your shop.",
  ctaData: {
    ctaText: "LEARN MORE",
    anchorLink: "https://www.bystadium.com/branded-merch/",
  },
  image: swagStoreBannerImage,
};

export const COLLAPSIBLE_BANNER_PREFIX = "collapsible-banner"

export const getBannerStorageKey = (storeNumber, id) => `${COLLAPSIBLE_BANNER_PREFIX}-${storeNumber}-${id}`;
